export default "__VITE_PUBLIC_ASSET__b1305b4f__"